import styled from '@emotion/styled';

const Container = styled.div`
  padding: 3.5rem 0;

  & > div {
    position: relative;
    height: 3rem;
    margin: 0.3rem;

    & > .card {
      transition: transform 0.3s ease;
      user-select: none;

      &:hover,
      &:active,
      &:focus {
        transform: scale(1.05) translateY(-0.5rem) translateX(2rem);
        opacity: 1;
      }
    }
  }
`;

export { Container };
